<template>
  <v-dialog
    v-model="dialog.value"
    :persistent="dialog.persistent"
    :fullscreen="dialog.fullscreen"
    :max-width="dialog.maxWidth"
  >
    <v-card>
      <v-card-title v-if="dialog.title" class="primary white--text title">
        {{ dialog.title | cap }}
      </v-card-title>
      <v-card-text>
        {{ dialog.text | cap }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="dialog.info"
          color="primary"
          @click="cancel()"
        >OK</v-btn>
        <div v-else>
          <v-btn
            flat
            @click="cancel()"
          >{{ $t(dialog.cancel) }}</v-btn>
          <v-btn
            color="primary"
            @click="submit()"
          >{{ $t(dialog.submit) }}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  created () {
    this.setDialog()
  },

  computed: {
    ...mapGetters('_Dialog', { dialog: 'GET' })
  },

  methods: {
    ...mapActions('_Dialog', { setDialog: 'SET_DIALOG' }),
    cancel () {
      this.setDialog({action: 'cancel'})
    },
    submit () {
      this.setDialog({action: 'submit'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialog.vue